import { H_RPQS_DASHBOARD, H_RPQS_OPTIONS } from 'account/constants/AccessRulesConstants'
import { ALIGN } from 'components/datatable/NewTable'
import FixedSlideNav from 'components/navbar/FixedSlideNav'
import BoundaryError from 'log/components/BoundaryError'
import React, { useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { Outlet, useParams } from 'react-router'
import RpqsAction from 'rpqs/actions/RpqsAction'
import i18n from 'simple-react-i18n'

const ManagementEntityApp = () => {
    const dispatch = useDispatch()
    const { annee, idCollectivite, ideg } = useParams()

    const navLinks = useMemo(() => {
        return [{
            icons: 'dashboard',
            name: i18n.dashboard,
            href: `/rpqs/${annee}/collectivite/${idCollectivite}/eg/${ideg}/dashboard`,
            habilitation: H_RPQS_DASHBOARD,
        }, {
            icons: 'compare_arrows',
            name: i18n.descriptive,
            href: `/rpqs/${annee}/collectivite/${idCollectivite}/eg/${ideg}/descriptive`,
            habilitation: '',
        }, {
            icons: 'event',
            name: i18n.event,
            href: `/rpqs/${annee}/collectivite/${idCollectivite}/eg/${ideg}/event`,
            habilitation: '',
        }, {
            icons: 'perm_media',
            name: i18n.picturesAndDocuments,
            href: `/rpqs/${annee}/collectivite/${idCollectivite}/eg/${ideg}/documents`,
            habilitation: '',
        }, {
            icons: 'insert_chart',
            name: i18n.statistics,
            href: `/rpqs/${annee}/collectivite/${idCollectivite}/eg/${ideg}/statistics`,
            habilitation: '',
        }, {
            icons: 'settings',
            name: i18n.settings,
            href: '/rpqs/option',
            habilitation: H_RPQS_OPTIONS,
            position: ALIGN.BOTTOM,
        }]
    }, [annee, idCollectivite, ideg])

    useEffect((() => {
        dispatch(RpqsAction.fetchRpqs(annee, idCollectivite))
        dispatch(RpqsAction.fetchManagementUnitById(ideg))
    }), [annee, idCollectivite, ideg])

    return (
        <div className='row no-margin'>
            <FixedSlideNav links={navLinks}/>
            <main>
                <div className='row no-margin padding-left-1'>
                    <div className='content-page no-padding fullscreen'>
                        <BoundaryError>
                            <Outlet />
                        </BoundaryError>
                    </div>
                </div>
            </main>
        </div>
    )
}

export default ManagementEntityApp
